const cdnNumber = Math.ceil(Math.random() * 4)
function getBlogBaseUrl() {
  return Config.production ? `https://tistory${cdnNumber}.daumcdn.net/tistory` : 'https://beta.daumcdn.net/tistory_test'
}

class CDN {
	static getBlogUrl(path) {
		return `${getBlogBaseUrl()}${path}`
	}
}

export default CDN
